import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-add-invoice-item',
    templateUrl: './add-invoice-item.component.html',
    styleUrls: ['./add-invoice-item.component.scss'],
    standalone: false
})
export class AddInvoiceItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
